import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import './Navbar.css'
import logo from "../../../assets/LMS_logo.svg";
import userLogo from "../../../assets/profile-account.png";
import { useDispatch, useSelector } from 'react-redux';
import Tooltip from '../tooltip/Tooltip';
import Avatar from './Avatar';
import CustomPopover from '../custompopover/CustomPopover';
import { Menu } from "lucide-react";
import CustomButton from '../button/CustomButton';
import { Button } from 'antd';
import hamburger from '../../../assets/icons/hamburger-icon.svg'
import ResetPasswordModal from '../modal/ResetPasswordModal';
import { logout, setPortal } from '../../../redux/authentication/authActions';
import { CgProfile } from 'react-icons/cg';

const Navbar = () => {
    const auth = useSelector(state => state.auth)
  const dispatch = useDispatch();
  const navigate = useNavigate();
   const [loading, setLoading] = useState(false);
  const [isResetPasswordModalOpen, setIsResetPasswordModalOpen] = useState(false);
  const fullName = auth?.fullName;
  const nextPortal =
  auth.currentPortal === "admin" ? "user" : "admin";
   const handleCloseResetPassword = () => {
    setIsResetPasswordModalOpen(false);
  };
   
    const parseJwt = (token) => {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => `%${('00' + c.charCodeAt(0).toString(16)).slice(-2)}`)
        .join('')
    );
    return JSON.parse(jsonPayload);
  };
   const userId = auth?.accessToken ? parseJwt(auth.accessToken).userId : null;
  const handleLogout = () => {
    localStorage.removeItem('authtoken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('selectedId');
    dispatch(logout());
    navigate('/login');
  };


const handleSwitch = () => {
  const nextPortal =
    auth.currentPortal === "admin" ? "user" : "admin";

  dispatch(setPortal(nextPortal));
  localStorage.setItem("currentPortal", nextPortal);

  navigate(nextPortal === "admin" ? "/admin" : "/user");
};
   const popoverContent = (
    <div
      style={{
        width: "240px",
        display: "flex",
        flexDirection: "column",
        gap: "10px",
      }}
    >
     
      <Button
       className='navbar-item'
       
        onClick={()=>{
          setIsResetPasswordModalOpen(true);
        }}
      >
        <span>Change Password</span>
          <img src={hamburger} alt="menu" />
      </Button>

      {auth.roles.includes("ADMIN_SUPPORT") &&  <Button
       className='navbar-item'
       onClick={handleSwitch}
        >
        <span>Switch to {nextPortal === "admin" ? "Admin Role" : "Employee Role"}</span>
          <CgProfile size={24} color='#979696' />
      </Button>
        }
      <CustomButton
        style={{
          width: "11rem",
        }}
        variant="outlined"
        onClick={handleLogout}
      >
        Logout
      </CustomButton>
    </div>
  );
  return (
    auth && (
      <nav className="navbar">
        <ul className="navbar-menu">
          <li className="navbar-logo">
            <Link to={auth?.roles?.includes("ADMIN") ? "/admin" : "/user"}>
              <img src={logo} alt="logo" className='logo' style={{ width: '70px', height: 'auto' }} />
            </Link>
          </li>
          <li className="nav-link">
            {auth?.roles ? (
              <>
                {/* <Link to="/about" className='navbar-item nav-items'>About Us</Link> */}
                {/* <Link to="/contact" className='navbar-item nav-items'>Contact Us</Link> */}
                <div className='navbar-logo-profile-logo'>
                  {/* <Tooltip tooltipText={`Welcome, ${auth?.fullName}`} placement="bottom"> */}
                <CustomPopover
                    style={{
                      width: "240px",
                    }}
                    content={popoverContent}
                    placement="bottomRight"
                    trigger="click"
                  >

                      <Menu
                        style={{
                color: "white",
                cursor: "pointer",
                fontSize: "24px",
              }}
                      />
            
                  </CustomPopover>
                  {/* </Tooltip> */}
                </div>
              </>
            ) : (
              <>
                <Link to="/about" className='navbar-item nav-items'>About Us</Link>
                <Link to="/contact" className='navbar-item nav-items'>Contact Us</Link>
                Not logged In.
              </>
            )
            }
          </li>
        </ul>
         <ResetPasswordModal
      isModalOpen={isResetPasswordModalOpen}
      handleCloseModal={handleCloseResetPassword}
      userId={userId}
      setLoading={setLoading}
      logout = {handleLogout}
    />
      </nav>
    )
  )
}

export default Navbar
